import(/* webpackMode: "eager" */ "/codebuild/output/src2706877171/src/football-trends-face/src/app/[locale]/league/_league.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2706877171/src/football-trends-face/src/app/[locale]/league/[leagueId]/LeagueInfo.tsx");
